// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"topic_wrapper___qPze"};